
(function() {
    let timer = setInterval(function() {
        try {
            let cbbAlsoBoughtProduct = document.querySelectorAll('.cbb-also-bought-product');
    
            if (cbbAlsoBoughtProduct && cbbAlsoBoughtProduct.length) {
                clearTimeout(timer);
    
                for (let i = 0; i < cbbAlsoBoughtProduct.length; i++) {
                    const link = cbbAlsoBoughtProduct[i].querySelector('.cbb-also-bought-product-image-link').dataset.href;
                    const atc = cbbAlsoBoughtProduct[i].querySelector('.cbb-also-bought-add-to-cart-button');
                    const newAtc = atc.cloneNode(true);
                    cbbAlsoBoughtProduct[i].replaceChild(newAtc, atc);
                    if (newAtc.children.length) {
                        newAtc.children[0].innerText = "VIEW MORE";
                    } else {
                        newAtc.innerText = "VIEW MORE";
                    }
                    newAtc.addEventListener('click', function() {
                        window.location.href = link;
                    });
                }
            }
        } catch (err) {
            console.error('Combowise cart custom script error: ', err);
            clearTimeout(timer);
        }
    }, 1000);
})();
